(() => {
  function initHeader(root) {
    root.querySelectorAll('header-menu').forEach((menu) => {
      if (menu.dataset.pgReady) return;
      menu.dataset.pgReady = 'true';
      const details = menu.querySelector('details');
      const summary = details.querySelector('summary');
      let restoringFocus = false;
      let closeTimer;
      const sync = () => summary.setAttribute('aria-expanded', String(details.open));
      const close = () => { details.open = false; sync(); };
      const open = () => {
        clearTimeout(closeTimer);
        if (!window.matchMedia('(min-width: 990px)').matches) return;
        root.querySelectorAll('header-menu > details[open]').forEach((other) => {
          if (other !== details) {
            other.open = false;
            other.querySelector('summary').setAttribute('aria-expanded', 'false');
          }
        });
        details.open = true;
        sync();
      };
      summary.setAttribute('role', 'button');
      details.addEventListener('toggle', sync);
      menu.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse') open();
      });
      menu.addEventListener('pointerleave', () => {
        // Bridge the header's vertical padding while moving into the panel.
        closeTimer = setTimeout(() => {
          if (!menu.contains(document.activeElement)) close();
        }, 160);
      });
      menu.addEventListener('focusin', (event) => {
        if (!restoringFocus && event.target === summary && summary.matches(':focus-visible')) open();
      });
      menu.addEventListener('focusout', () => {
        queueMicrotask(() => { if (!menu.contains(document.activeElement)) close(); });
      });
      menu.addEventListener('keyup', (event) => {
        if (event.key !== 'Escape' || !details.open) return;
        event.stopImmediatePropagation();
        restoringFocus = true;
        close();
        summary.focus();
        restoringFocus = false;
      }, true);
      sync();
    });

    root.querySelectorAll('header-drawer').forEach((drawer) => {
      if (drawer.dataset.pgReady) return;
      drawer.dataset.pgReady = 'true';
      const main = drawer.querySelector('#Details-menu-drawer-container');
      const summary = main.querySelector('summary');
      const groups = drawer.querySelectorAll('[data-pg-accordion]');
      groups.forEach((group) => {
        group.addEventListener('toggle', () => {
          group.querySelector('summary').setAttribute('aria-expanded', String(group.open));
        });
      });
      // Dawn binds every nested summary/button to its sliding submenus. These
      // groups are native accordions; search buttons keep their form actions.
      drawer.addEventListener('click', (event) => {
        if (event.target.closest('[data-pg-accordion] > summary, .pg-header-search button')) event.stopPropagation();
        if (event.target.closest('[data-pg-drawer-close]')) {
          event.stopPropagation();
          drawer.closeMenuDrawer(event, summary);
          summary.setAttribute('aria-expanded', 'false');
        }
      }, true);
      drawer.addEventListener('keyup', (event) => {
        const group = event.target.closest('[data-pg-accordion][open]');
        if (event.key === 'Escape' && group) {
          event.stopPropagation();
          group.open = false;
          group.querySelector('summary').setAttribute('aria-expanded', 'false');
          group.querySelector('summary').focus();
        }
      }, true);
      main.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(main.open));
        if (main.open) trapFocus(main.querySelector('#menu-drawer'), drawer.querySelector('[data-pg-drawer-close]'));
        if (!main.open) groups.forEach((group) => {
          group.open = false;
          group.querySelector('summary').setAttribute('aria-expanded', 'false');
        });
      });
    });

    root.querySelectorAll('.pg-header-search predictive-search, .pg-header-search search-form').forEach((search) => {
      if (search.dataset.pgHeaderReady) return;
      search.dataset.pgHeaderReady = 'true';
      const input = search.querySelector('input[type="search"]');
      const zeroQuery = search.querySelector('[data-pg-zero-query]');
      const hideSuggestions = () => {
        zeroQuery.hidden = true;
        if (typeof search.close === 'function') search.close();
      };
      const showZeroQuery = () => { zeroQuery.hidden = Boolean(input.value.trim()); };
      input.addEventListener('focus', showZeroQuery);
      input.addEventListener('click', showZeroQuery);
      input.addEventListener('input', showZeroQuery);
      search.addEventListener('focusout', () => {
        queueMicrotask(() => { if (!search.contains(document.activeElement)) hideSuggestions(); });
      });
      search.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') hideSuggestions();
      });
      const panel = search.querySelector('[data-predictive-search]');
      if (!panel) return;
      // Shopify returns the same IDs for every predictive search instance.
      // Namespace returned IDs and their references within each search form.
      new MutationObserver(() => {
        const ids = new Map();
        panel.querySelectorAll('[id]').forEach((element) => {
          const original = element.dataset.pgOriginalId || element.id;
          element.dataset.pgOriginalId = original;
          element.id = `${input.id}-${original}`;
          ids.set(original, element.id);
        });
        panel.querySelectorAll('[aria-labelledby], [aria-describedby], [aria-controls]').forEach((element) => {
          ['aria-labelledby', 'aria-describedby', 'aria-controls'].forEach((attribute) => {
            if (element.hasAttribute(attribute)) element.setAttribute(attribute,
              element.getAttribute(attribute).split(' ').map((id) => ids.get(id) || id).join(' '));
          });
        });
        const listbox = panel.querySelector('[role="listbox"]');
        input.setAttribute('aria-controls', listbox ? listbox.id : panel.id);
      }).observe(panel, { childList: true, subtree: true });
      // Dawn clears this wrapper by its original ID before fetching a new term.
      input.addEventListener('input', () => {
        if (search.searchTerm && !input.value.trim().startsWith(search.searchTerm)) {
          panel.querySelector('[data-pg-original-id="predictive-search-results-groups-wrapper"]')?.remove();
        }
      });
    });
  }
  const init = (scope) => scope.querySelectorAll('.pg-header').forEach(initHeader);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document));
  else init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
